import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IAccountB2CRetrievalGenerateOTPUseCase {
    execute(username: string): Promise<any>;
}

export class AccountB2CRetrievalGenerateOTPUseCase implements IAccountB2CRetrievalGenerateOTPUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(username: string): Promise<any> {
        const result = await this.profileRepository.accountB2CRetrievalGenerateOTP(username);
        return result.data;
    }
}
